module.exports = __webpack_public_path__ + "media/images/banner/wowjapan/sidebar/kr-2dd8959f8f08b7555ad2dc46b46a5019.jpg";